import { useCallback } from "react";

import { useModals } from "hooks";
import { useDealActions } from "store";
import { IFile } from "store/types";

import { useClientWorkspaceCtx } from "../context/ClientWorkspace-context";

export interface UseFileHookParams {
  file: { id: number; name: string };
  refetchHandler?: () => Promise<void>;
}

export const useFileHook = ({ file }: UseFileHookParams) => {
  const { deleteModal } = useModals();
  const { downloadFileAction, deleteFileAction } = useDealActions();
  const { removeFiles } = useClientWorkspaceCtx();

  const handleDownload = useCallback(() => {
    downloadFileAction({ fileId: file.id, fileName: file.name });
  }, [downloadFileAction, file.id, file.name]);

  const handleDelete = useCallback(() => {
    return deleteModal({
      element: "Delete item permanently?",
      message: "This cannot be undone",
      onPressSuccess: "Delete permanently",
      action: async () => {
        await deleteFileAction({ id: file.id, name: file.name, deal_id: null } as unknown as IFile);
        // Drop the row from the table optimistically — no full metadata refetch.
        removeFiles([file.id]);
      }
    });
  }, [deleteModal, deleteFileAction, removeFiles, file.id, file.name]);

  return {
    handleDownload,
    handleDelete,
    handleShare: undefined,
    handleAddTask: undefined,
    handleDataExtraction: undefined,
    handleExtractK1: undefined,
    handleLookThrough: undefined,
    handleFileInfo: undefined,
    handleAddValueFromPDF: undefined
  };
};
